// extracted by mini-css-extract-plugin
export default {"examRules":"style_examRules__gRba5","rule":"style_rule__KcXmg","rule_title":"style_rule_title__eZ6-x","rule_description":"style_rule_description__lUBXP"};